import React, { Fragment } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Typography } from "@mui/material";
import Labels from "../labels/Labels";

export default function MissingTimeAttendance(props) {
  const columns = [
    {
      field: "id",
      headerName: Labels.getLabel("missingTimeAttendance.column.id", "ID"),
      width: 70,
    },
    {
      field: "transactionDate",
      headerName: Labels.getLabel(
        "missingTimeAttendance.column.transactionDate",
        "Transaction Date"
      ),
      width: 130,
      renderCell: (params) => {
        return (
          <Typography sx={{ fontSize: 12, mb: 0 }} gutterBottom>
            {params.row.transactionDate}
          </Typography>
        );
      },
    },
    {
      field: "transactionDescription",
      headerName: Labels.getLabel(
        "missingTimeAttendance.column.transactionDescription",
        "Description"
      ),
      width: 120,
      renderCell: (params) => {
        return (
          <Typography sx={{ fontSize: 12, mb: 0 }} gutterBottom>
            {params.row.transactionDescription}
          </Typography>
        );
      },
    },
    {
      field: "email",
      headerName: Labels.getLabel(
        "missingTimeAttendance.column.email",
        "Email"
      ),
      width: 180,
      renderCell: (params) => {
        return (
          <Typography sx={{ fontSize: 12, mb: 0 }} gutterBottom>
            {params.row.email}
          </Typography>
        );
      },
    },
    {
      field: "firstName",
      headerName: Labels.getLabel(
        "missingTimeAttendance.column.firstName",
        "First Name"
      ),
      width: 100,
      renderCell: (params) => {
        return (
          <Typography sx={{ fontSize: 12, mb: 0 }} gutterBottom>
            {params.row.firstName}
          </Typography>
        );
      },
    },
    {
      field: "lastName",
      headerName: Labels.getLabel(
        "missingTimeAttendance.column.lastName",
        "Last Name"
      ),
      width: 100,
      renderCell: (params) => {
        return (
          <Typography sx={{ fontSize: 12, mb: 0 }} gutterBottom>
            {params.row.lastName}
          </Typography>
        );
      },
    },
    {
      field: "memberId",
      headerName: Labels.getLabel(
        "missingTimeAttendance.column.memberId",
        "Member Id"
      ),
      width: 120,
      renderCell: (params) => {
        return (
          <Typography sx={{ fontSize: 12, mb: 0 }} gutterBottom>
            {params.row.memberId}
          </Typography>
        );
      },
    },
    {
      field: "companyName",
      headerName: Labels.getLabel(
        "missingTimeAttendance.column.companyName",
        "Company Name"
      ),
      width: 200,
      renderCell: (params) => {
        return (
          <Typography sx={{ fontSize: 12, mb: 0 }} gutterBottom>
            {params.row.companyName + " (" + params.row.companyId + ")"}
          </Typography>
        );
      },
    },
    {
      field: "amount",
      headerName: Labels.getLabel(
        "missingTimeAttendance.column.amount",
        "Amount"
      ),
      width: 90,
      renderCell: (params) => {
        return (
          <Typography sx={{ fontSize: 12, mb: 0 }} gutterBottom>
            {params.row.amount}
          </Typography>
        );
      },
    },
  ];
  const { isLoading, isError, data } = props;
  return (
    <Fragment>
      <h1>
        {Labels.getLabel(
          "missingTimeAttendance.title",
          "Missing Time and Attendance"
        )}
      </h1>
      {isLoading ? (
        <h4>
          {Labels.getLabel("missingTimeAttendance.loading", "Loading...")}
        </h4>
      ) : !isError ? (
        <div style={{ height: 500, width: "100%" }}>
          <DataGrid
            columnVisibilityModel={{ id: false }}
            disableSelectionOnClick
            disableColumnFilter
            disableColumnSelector
            disableDensitySelector
            rows={data?.data}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[10]}
            components={{ Toolbar: GridToolbar }}
            componentsProps={{
              toolbar: {
                showQuickFilter: true,
                quickFilterProps: { debounceMs: 500 },
              },
            }}
          />
        </div>
      ) : (
        <h4>
          {Labels.getLabel(
            "missingTimeAttendance.error",
            "An error ocurred, please try again later..."
          )}
        </h4>
      )}
    </Fragment>
  );
}
